import React from "react";
import "../../styles/franchise.css";

const FranchiseHero = () => {
  return (
    <div className="fr">
      <section className="fr-hero">
        <div className="fr-glow" />

        <div className="container position-relative z-1 text-center">
          <p className="fr-eyebrow">
            <span className="fr-eyebrow-dot" />
            HKI Studio
          </p>

          <h1 className="fr-title">YOUR TOWN. YOUR STUDIO.</h1>
          <h2 className="fr-title-hi">आपका शहर। आपका स्टूडियो।</h2>
          <p className="fr-tag">Franchise Enquiry Form / फ्रैंचाइज़ी पूछताछ फॉर्म</p>

          <p className="fr-subtitle">
            Open an HKI Studio in your tehsil and bring professional
            creative, digital marketing, and media services closer to local
            businesses, people, and events.
          </p>
          <p className="fr-subtitle">
            अपने तहसील में HKI Studio शुरू करें और स्थानीय व्यवसायों, लोगों
            एवं इवेंट्स को प्रोफेशनल क्रिएटिव, डिजिटल मार्केटिंग और मीडिया
            सेवाएँ उपलब्ध कराएँ।
          </p>
        </div>
      </section>
    </div>
  );
};

export default FranchiseHero;
